import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateDocumentRequestFailure() {
      return getState().isFailure;
    },
    isCreateDocumentRequestPending() {
      return getState().isPending;
    },
    isCreateDocumentRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
